var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.895 0.000300407L15.1317 1.23813L8.39183 7.9803C8.28384 8.08898 8.15542 8.17523 8.01396 8.23409C7.8725 8.29294 7.7208 8.32324 7.56758 8.32324C7.41437 8.32324 7.26267 8.29294 7.12121 8.23409C6.97975 8.17523 6.85133 8.08898 6.74333 7.9803L0 1.23813L1.23667 0.00146675L7.56583 6.32947L13.895 0.000300407Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/ArrowDown.9f7c90f1a817efd057fb8f330e18e15c.svg";
export { ForwardRef as ReactComponent };